module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-steel-blue-015-1200x2490.96ae7210.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-steel-blue-015-1200x2490.jpg
// module id = 1101
// module chunks = 37